/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { map } from 'rxjs/operators';
import { DataSource } from 'angular2-smart-table/lib/lib/data-source/data-source';
import { Language } from 'src/app/shared/enums/languages';

@Injectable()
export class UsersApi {
  private readonly apiController: string = 'users';
  private readonly apiAuthController: string = 'auth';

  constructor(private api: HttpService) { }

  get usersDataSource(): DataSource {
    return this.api.getServerDataSource(`${this.api.apiUrl}/${this.apiController}`);
  }

  list(pageNumber: number = 1, pageSize: number = 10): Observable<any[]> {
    const params = new HttpParams()
      .set('pageNumber', `${pageNumber}`)
      .set('pageSize', `${pageSize}`);

    return this.api.get(this.apiController, { params })
      .pipe(map(data => data.map(item => {
        const picture = `${this.api.apiUrl}/${this.apiController}/${item.id}/photo`;
        return { ...item, picture };
      })));
  }

  getCurrent(): Observable<any> {
    return this.api.get(`${this.apiController}/current`)
      .pipe(map(data => {
        const picture = `${this.api.apiUrl}/${this.apiController}/${data.id}/photo`;
        return { ...data, picture };
      }));
  }

  getCurrentwithInfo(): Observable<any> {
    return this.api.get(`${this.apiController}/currentwithinfo`)
      .pipe(map(data => {
        const picture = `${this.api.apiUrl}/${this.apiController}/${data.id}/photo`;
        return { ...data, picture };
      }));
  }

  resetPassword(request): Observable<any> {
    return this.api.post(`${this.apiAuthController}/reset-pass`, request)
      .pipe(map(data => {
        return data;
      }));
  }

  get(id: number): Observable<any> {
    return this.api.get(`${this.apiController}/${id}`)
      .pipe(map(data => {
        const picture = `${this.api.apiUrl}/${this.apiController}/${data.id}/photo`;
        return { ...data, picture };
      }));
  }

  delete(id: number): Observable<boolean> {
    return this.api.delete(`${this.apiController}/${id}`);
  }

  add(item: any): Observable<any> {
    return this.api.post(this.apiController, item);
  }

  updateCurrent(item: any): Observable<any> {
    return this.api.put(`${this.apiController}/current`, item);
  }

  update(item: any): Observable<any> {
    return this.api.put(`${this.apiController}/${item.id}`, item);
  }

  public setLocale(locale: Language): Observable<string> {
    return this.api.post(`${this.apiController}/setLocale`, { locale });
  }

  verifyOtp(payload): Observable<any> {
    return this.api.post(`${this.apiAuthController}/otp/verify`, payload);
  }

  resendOtp(payload): Observable<any> {
    return this.api.post(`${this.apiAuthController}/otp/resend`, payload);
  }

  login(payload): Observable<any> {
    return this.api.post(`${this.apiAuthController}/login`, payload);
  }

  resetCookie(): Observable<any> {
    return this.api.post(`${this.apiAuthController}/reset-cookie`, {});
  }

  isCookieValid(): Observable<any> {
    return this.api.get(`user`);
  }
}
